import { FC } from "react";
import { IonCard, IonItem } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { get } from "lodash";
import { R6IonInput } from "../../../components/r6ionic/R6IonInput";

export interface MagicLinkFormProps {
    onSubmit: () => void | Promise<void>;
    continueLabel: string;
    isEmailEntered: boolean;
}

export const MagicLinkForm: FC<MagicLinkFormProps> = ({
    onSubmit,
    continueLabel,
    isEmailEntered,
}) => {
    const { t } = useTranslation();
    const {
        formState: { errors },
    } = useFormContext();

    return (
        <IonCard color="transparent">
            <form
                id="login-email-form"
                onSubmit={(event) => {
                    event.preventDefault();
                    onSubmit();
                }}
            >
                <R6IonInput
                    name="email"
                    testId="usernameInput"
                    rules={{
                        required: t("utils.ErrorMessages.required").toString(),
                    }}
                    inputMode="email"
                    autocapitalize="off"
                    label={t("login.login.emailPlaceholder")}
                />
            </form>
        </IonCard>
    );
};
